import { CARE_PLAN_SERVICE_NAME } from '@/api';

export const SKU_PACKAGE_MAP: Record<number, string | undefined> = {
  100: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_100,
  200: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_200,
  300: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_300,
  350: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_350,
  370: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_370,
  400: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_400,
  500: CARE_PLAN_SERVICE_NAME.IMAGING_LEGACY_SKU_500,
};
